import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import AppLayout from "../components/AppLayout";
import BoxComponent from "../components/BoxTile";
import {  ArrowBack } from "@mui/icons-material";
import "../css/NewAgenSelectorScreen.css"; // Apply the CSS file
import { saveSlugName } from "../redux/slices/CreateAgentSlice";
import {getImages} from '../utills/lib'; // Ensure this utility function is correctly imported
import { deleteAiAgent, resetDeleteAgent } from "../redux/slices/DeployAIAgent";
import { CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const AgentListDashboard = () => {
  const { agentList, agentListLoading } = useSelector((state) => state.LoadAIAgentsSlice);
  const { deleteAgentLoading, deleteAgentError, deleteAgentSuccess } = useSelector((state) => state.DeploySlice);
  console.log('agentList===>123',agentList)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [agentToDelete, setAgentToDelete] = React.useState(null);

  React.useEffect(() => {
    if (deleteAgentSuccess) {
      setDeleteDialogOpen(false);
      setAgentToDelete(null);
      dispatch(resetDeleteAgent());
      // Optionally, refresh the agent list here if needed
    }
  }, [deleteAgentSuccess, dispatch]);

  const handleDeleteClick = (agent) => {
    setAgentToDelete(agent);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (agentToDelete) {
      dispatch(deleteAiAgent(agentToDelete?.slug));
    }
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setAgentToDelete(null);
    dispatch(resetDeleteAgent());
  };

  const getBackgroundColor = (data) => { // Ensure field is always an object
    const name = data
  
    if (name === 'invoice') {
      return '#E6D5FF'
    }
    if (name === 'moad-so') {
      return '#D5FEE6';
    }
    return  '#E6D5FF'
  }





  // Agent List Component with Skeleton
  const AgentList = ({ activieSystemAiAgentList }) => {
    if (agentListLoading) {
      return (
        <div className="agent-list-container">
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={200}
              height={120}
              sx={{ borderRadius: "8px", marginBottom: "16px" }}
            />
          ))}
        </div>
      );
    }

    return (
      <div className="agent-list-container">
 {activieSystemAiAgentList.map((box) => (
  <div
    key={box.id}
    style={{
      marginBottom: '24px',
      borderRadius: '12px',
      overflow: 'hidden', // ensures rounded corners apply to buttons too
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e0e0',
    }}
  >
    <BoxComponent
      isLoadMyAgent
      backgroundColor={getBackgroundColor(box.ai_agent)}
      image={getImages(box.ai_agent)}
      title={box.name}
      subtitle={box.slug}
    />
    <div
      style={{
        display: 'flex',
        borderTop: '1px solid #ccc',
      }}
    >
      <button
        onClick={() =>{
          dispatch(saveSlugName(box.slug))
          navigate("/NewAgentViewerScreen", { state: { box, statusDefault: "Completed" } });
        }}
        style={{
          flex: 1,
          padding: '10px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderBottomLeftRadius: '12px',
          cursor: 'pointer',
        }}
      >
        Load
      </button>
      <button
       disabled ={box.ai_agent === 'invoice'}
       onClick={() =>{
        dispatch(saveSlugName(box.slug))
        navigate("/invoiceAgents", { state: {  steps: "Fields",slug:box?.ai_agent,slug_id:box?.slug } });
      }}
        style={{
          flex: 1,
          opacity:box.ai_agent === 'invoice' ? 0.5:1,
          padding: '10px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Edit
      </button>
      <button
        onClick={() => handleDeleteClick(box)}
        style={{
          flex: 1,
          padding: '10px',
          backgroundColor: '#F44336',
          color: 'white',
          border: 'none',
          borderBottomRightRadius: '12px',
          cursor: 'pointer',
        }}
      >
        Delete
      </button>
    </div>
  </div>
))}

      </div>
    );
  }    
  return (
    <AppLayout>
          <Box className="header-section">
          <ArrowBack
            onClick={() => navigate("/agentSelection")}
            className="back-icon"
          />
          <h2 className="header-title">Back</h2>
        </Box>

      <h2 className="custom-title">Load My Agents</h2>
      <AgentList activieSystemAiAgentList={agentList} />
      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this AI agent? This process cannot be undone.</Typography>
          {deleteAgentError && (
            <Typography color="error" sx={{ mt: 2 }}>{deleteAgentError}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} variant="outlined" color="primary" disabled={deleteAgentLoading}>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant="contained" color="error" disabled={deleteAgentLoading}>
            {deleteAgentLoading ? <CircularProgress size={20} color="inherit" /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </AppLayout>
  );
};

export default AgentListDashboard;
